import React, { useEffect } from 'react'
import './All_albums.css'
import Common_Back_Header from '../common/common_components/common_back_header/Common_Back_Header'
import Music_card from '../common/common_components/music-card/Music_card'
import Pravachan_Card from '../insight/gurujis_pravachan/pravachan_card/Pravachan_Card'
import { useDispatch, useSelector } from 'react-redux'
import { closestTagName } from '@progress/kendo-react-data-tools'
import { AllChants, AllChantsAlbum } from '../../features/admin/common/Slice'
import Common_Title_1 from '../common/common_components/common_title_1/Common_Title_1'
import { useNavigate } from 'react-router-dom'
import { encodeId } from '../../utils/common'

const All_albums = () => {

    const dispatch = useDispatch();
    const chantsAl = useSelector((state) => state.common.all_chants_album);

    useEffect(() => {
        dispatch(AllChantsAlbum());
    }, [dispatch]);

    const navigate = useNavigate()

    return (
        <>
            <section className='All_albums_sec'>
                <div className='container'>


                    <Common_Back_Header backNavigation={-1} />
                    {/* <div className='banner_div'>
                        <img className='banner_img' src={process.env.PUBLIC_URL + '/assets/images/sadguru-arpanam/banner.png'} />
                    </div> */}

                    <Common_Title_1 titleText={"All Albums"} />

                    <div className='row'>
                        <div className='col-md-11 mx-auto'>
                            <div className='almb_sec all_album_custom'>

                                {/* <div className='musix_box'>
                                    <div className='namediv'>
                                        <h6 className='name'>Vairagya Reprise</h6>
                                        <h6 className='name'>8 Chants</h6>
                                    </div>
                                    <div className='icondiv'>
                                        <img className='playicon' src={process.env.PUBLIC_URL + '/assets/images/icons/play2.png'} alt="play-btn" />
                                    </div>
                                </div> */}

                                <div className='all_albulms'>
                                    <div className='row'>
                                        {chantsAl?.map((item, index) => {
                                            return (
                                                <div className='col-lg-3'>
                                                    <div className='albm_div' key={index} onClick={() => navigate(`/all-album-chants/${encodeId(item?.id)}`)}>
                                                        <Pravachan_Card
                                                            image={item?.image}
                                                            name={item?.name}
                                                            // album={item?.Chant_Type?.name}
                                                            music={item}
                                                        />
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </section>
        </>
    )
}

export default All_albums